import { useParams } from "react-router-dom"
import TutorCourseEdit from "./course_edit"



const SelectedCourseEdit = () => {
    const id = useParams()

    return (
        <>
            <TutorCourseEdit id={id.id} />
        </>
    )
}

export default SelectedCourseEdit